import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import {
  RentalImageEnhanceRevertDialogComponent,
  RentalImageEnhanceRevertDialogData,
} from './rental-image-enhance-revert-dialog.component'
import { Observable } from 'rxjs'

@Injectable()
export class RentalImageEnhanceRevertDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: RentalImageEnhanceRevertDialogData): Observable<void> {
    const defaultConfig: MatDialogConfig = {
      width: '750px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data,
    }

    return this.dialog.open(RentalImageEnhanceRevertDialogComponent, defaultConfig).afterClosed()
  }
}
